import {AccountId, CurrencyCode, DoubleString, NonNegativeInt, Source} from '@raison/types';
import {ProviderId} from '~/entities/operations-fiat';

export interface OperableAccount extends OperableAccount.Identity {
    icon: Source;
    balance: DoubleString;
    balanceIn: DoubleString;
    balanceOut: DoubleString;
    currencyName: string;
    currencyCode: CurrencyCode;
    currencyDecimals: NonNegativeInt;
    providerId: ProviderId | null;
}

export namespace OperableAccount {
    export type Id = AccountId;

    export type Identity = {
        /**
         * ❗️WARNING❗️ this id is not guaranteed to be unique across types
         */
        id: AccountId;
        type: Type;
    };
    export type Type = 'fiat' | 'crypto' | 'stablecoin';

    export const isInCashGroup = ({type}: OperableAccount) => type === 'fiat';
    export const isInCryptoGroup = ({type}: OperableAccount) => type === 'crypto' || type === 'stablecoin';
}
